export default function ArchiveIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 12H5V7.003C5 6.449 5.455 6 5.992 6H18.008C18.1393 5.99973 18.2693 6.02556 18.3905 6.07601C18.5117 6.12645 18.6217 6.2005 18.714 6.29383C18.8063 6.38717 18.8791 6.49794 18.9282 6.61969C18.9773 6.74144 19.0017 6.87173 19 7.003V12H18V17.002C18.0005 17.266 17.8962 17.5194 17.71 17.7065C17.5239 17.8936 17.271 17.9992 17.007 18H6.993C6.72902 17.9992 6.47615 17.8936 6.28995 17.7065C6.10376 17.5194 5.99947 17.266 6 17.002V12ZM16 12H8V16H16V12ZM7 8V10H17V8H7Z"
        fill="#3C3C3C"
      />
    </svg>
  );
}
